import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

function PublicRoute({ children }: { children: JSX.Element }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const currentSelectedClient = sessionStorage.getItem("currentSelectedClient");

  const parsedCurrentSelectedClient = currentSelectedClient
    ? JSON.parse(currentSelectedClient)
    : null;

  useEffect(() => {
    if (user?.isAuthenticated) {
      const routes: Record<string, string> = {
        admin: "/admin/dashboard",
        client: "/client/dashboard",
        subClient: "/subclient/account-management/accounts",
      };

      let userType = user?.userType;

      if (currentSelectedClient) {
        userType = parsedCurrentSelectedClient?.role;
      }

      const redirectPath = routes[userType];
      if (redirectPath) {
        navigate(redirectPath, { replace: true });
      }
    }
  }, []);

  return children;
}

export default PublicRoute;
